import { getShortDate } from '../../../common/utils/dateTime';
import {
    waiverStatusConstants,
    mappedWaiverStatusConstants,
} from '../../../components/ChapterPage/ChapterAdminView/ChapterAdminConstants';

export class ForumManagement {
    constructor(obj) {
        this.name = obj.name || '';
        this.type = obj.type || '';
        this.status = obj.status || '';
        this.members = obj.members || 0;
        this.nonMembers = obj.nonMembers || 0;
        this.link = obj.salesForceId || '';
    }
}

export class ChapterOfficerManagement {
    constructor(obj) {
        this.positionId = obj.positionId || '';
        this.position = obj.positionTitle || '';
        this.name = obj.fullName || '';
        this.status = obj.status || '';
        this.startDate = getShortDate(new Date(obj.startDate), '/', 'M') || '';
        this.endDate = getShortDate(new Date(obj.endDate), '/', 'M') || '';
        this.link = `${obj.positionSalesForceId}` || '';
    }
}

export class ProspectManagement {
    constructor(obj) {
        this.name = `${obj.firstName} ${obj.lastName}` || '';
        this.pursueStatus = obj.pursueStatus || '';
        this.leadStatus = obj.status || '';
        this.qualifyingCompany = obj.qualifyingCompany || 0;
        this.applicationDate = getShortDate(new Date(obj.applicationDate), '/', 'M') || '';
        this.link = obj.salesforceId || '';
        this.waiverStatus = obj.waiverStatus || '';
        this.id = obj.id;
    }
}

export class ProspectsReadyToPay {
    constructor(obj) {
        this.name = obj.name || '';
        this.opportunityStatus = obj.stageName || '';
        this.dateConverted = getShortDate(new Date(obj.dateCreated), '/', 'M') || '';
        this.contactId = obj.salesforceId || '';
        this.link = obj.salesforceId || '';
    }
}

export class OverallChapterHealth {
    constructor(obj) {
        this.metric = obj.metric || 'test';
        this.metricValue = obj.metricValue || 1;
        this.pointsGiven = obj.pointsGiven || 1;
        this.showHelp = false;
    }
}

export const unwrapOverallChapterHealth = ({
    numberPrimaryMembersCurrent,
    totalNumberChapterEvents,
    chapterEdChairIdentified,
    ofFemalemembers,
    fmldCalculatedPercentage,
    percentageMembersForums,
    avMemberEventAttendCurrent,
    numberTrainedOfficers,
    percentageChapterRetention,
    isChapterrepresentationRegionalBoard,
    isCaworkshopAttendance,
    completedMemberProfiles,
    electCcand3moreOfficersby1Nov,
    isCurrentStrategicPlan,
    numberForumsTrainedModeratorScore,
    memberParticipationinForumScore,
    chaptereventparticipation,
    glcorClwattendance,
    chapterretentionrate,
    chapterrepresentedatRbmpastfiscalY,
    chapterAdministratorattendanceatCaw,
    completememberprofileonExchange,
    officerelectidentificationby1Oct,
    currentAnnualChapterStrategicPlan,
}) => [
    {
        metric: 'numberPrimaryMembersCurrent',
        metricValue:
            numberPrimaryMembersCurrent !== null && numberPrimaryMembersCurrent !== undefined
                ? numberPrimaryMembersCurrent
                : '',
        pointsGiven: '',
        showHelp: false,
    },
    {
        metric: 'totalNumberChapterEvents',
        metricValue:
            totalNumberChapterEvents !== null && totalNumberChapterEvents !== undefined ? totalNumberChapterEvents : '',
        pointsGiven: '',
        showHelp: false,
    },
    {
        metric: 'chapterEdChairIdentified',
        metricValue:
            chapterEdChairIdentified !== null && chapterEdChairIdentified !== undefined
                ? chapterEdChairIdentified
                : '',
        pointsGiven: '',
        showHelp: false,
    },
    {
        metric: 'ofFemaleMembers',
        metricValue:
        ofFemalemembers > 0
                ? 'false'
                : 'true',
        pointsGiven: '',
        showHelp: false,
    },
    {
        metric: 'fmldCalculatedPercentage',
        metricValue:
            fmldCalculatedPercentage !== null && fmldCalculatedPercentage !== undefined
                ? `${fmldCalculatedPercentage}%`
                : '',
        pointsGiven:
            numberForumsTrainedModeratorScore !== null && numberForumsTrainedModeratorScore !== undefined
                ? numberForumsTrainedModeratorScore
                : '',
        showHelp: false,
    },
    {
        metric: 'percentageMembersForums',
        metricValue:
            percentageMembersForums !== null && percentageMembersForums !== undefined
                ? `${percentageMembersForums}%`
                : '',
        pointsGiven:
            memberParticipationinForumScore !== null && memberParticipationinForumScore !== undefined
                ? memberParticipationinForumScore
                : '',
        showHelp: false,
    },
    {
        metric: 'avMemberEventAttendCurrent',
        metricValue:
        avMemberEventAttendCurrent !== null && avMemberEventAttendCurrent !== undefined
                ? `${avMemberEventAttendCurrent}%`
                : '',
        pointsGiven:
            chaptereventparticipation !== null && chaptereventparticipation !== undefined
                ? chaptereventparticipation
                : '',
        showHelp: false,
    },
    {
        metric: 'numberTrainedOfficers',
        metricValue: numberTrainedOfficers !== null && numberTrainedOfficers !== undefined ? numberTrainedOfficers : '',
        pointsGiven: glcorClwattendance !== null && glcorClwattendance !== undefined ? glcorClwattendance : '',
        showHelp: false,
    },
    {
        metric: 'percentageChapterRetention',
        metricValue: percentageChapterRetention !== null && percentageChapterRetention !== undefined ? `${percentageChapterRetention}%` : '',
        pointsGiven: chapterretentionrate !== null && chapterretentionrate !== undefined ? chapterretentionrate : '',
        showHelp: false,
    },
    {
        metric: 'isChapterrepresentationRegionalBoard',
        metricValue:
            isChapterrepresentationRegionalBoard !== null && isChapterrepresentationRegionalBoard !== undefined
                ? isChapterrepresentationRegionalBoard
                : '',
        pointsGiven:
            chapterrepresentedatRbmpastfiscalY !== null && chapterrepresentedatRbmpastfiscalY !== undefined
                ? chapterrepresentedatRbmpastfiscalY
                : '',
        showHelp: false,
    },
    {
        metric: 'isCaworkshopAttendance',
        metricValue:
            isCaworkshopAttendance !== null && isCaworkshopAttendance !== undefined ? isCaworkshopAttendance : '',
        pointsGiven:
            chapterAdministratorattendanceatCaw !== null && chapterAdministratorattendanceatCaw !== undefined
                ? chapterAdministratorattendanceatCaw
                : '',
        showHelp: false,
    },
    {
        metric: 'completedMemberProfiles',
        metricValue:
            completedMemberProfiles !== null && completedMemberProfiles !== undefined
                ? `${completedMemberProfiles}%`
                : '',
        pointsGiven:
            completememberprofileonExchange !== null && completememberprofileonExchange !== undefined
                ? completememberprofileonExchange
                : '',
        showHelp: false,
    },
    {
        metric: 'electCcand3moreOfficersby1Nov',
        metricValue:
            electCcand3moreOfficersby1Nov !== null && electCcand3moreOfficersby1Nov !== undefined
                ? electCcand3moreOfficersby1Nov
                : '',
        pointsGiven:
            officerelectidentificationby1Oct !== null && officerelectidentificationby1Oct !== undefined
                ? officerelectidentificationby1Oct
                : '',
        showHelp: false,
    },
    {
        metric: 'isCurrentStrategicPlan',
        metricValue:
            isCurrentStrategicPlan !== null && isCurrentStrategicPlan !== undefined ? isCurrentStrategicPlan : '',
        pointsGiven:
            currentAnnualChapterStrategicPlan !== null && currentAnnualChapterStrategicPlan !== undefined
                ? currentAnnualChapterStrategicPlan
                : '',
        showHelp: false,
    },
];

export const mapWaiver = (waiverStatus) => {
    if (waiverStatus.toLowerCase() === waiverStatusConstants.REQUESTED.toLowerCase()) {
        return mappedWaiverStatusConstants.REQUESTED;
    } else if (waiverStatus.toLowerCase() === waiverStatusConstants.APPROVED.toLowerCase()) {
        return mappedWaiverStatusConstants.APPROVED;
    } else if (waiverStatus.toLowerCase() === waiverStatusConstants.DENIED.toLowerCase()) {
        return mappedWaiverStatusConstants.DENIED;
    } else if (
        waiverStatus.toLowerCase() === waiverStatusConstants.CHAPTER_SUBMIT.toLowerCase() ||
        waiverStatus.toLowerCase() === waiverStatusConstants.CHAPTER_SUBMIT_NEW.toLowerCase()
    ) {
        return mappedWaiverStatusConstants.CHAPTER_SUBMIT;
    } else if (waiverStatus.toLowerCase() === waiverStatusConstants.NONE.toLowerCase()) {
        return mappedWaiverStatusConstants.NONE;
    } else if (waiverStatus.toLowerCase() === waiverStatusConstants.PENDING.toLowerCase()) {
        return mappedWaiverStatusConstants.PENDING;
    }
    return mappedWaiverStatusConstants.NONE;
};
